export const MAIN_LEFT_RIGHT_MARGIN = 16